import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { use } from "react";

import { useBrandPageProductsStateContext } from "../contexts/BrandPageProductsStateContext";

export interface IUseBrandProductResultData {
  productSearchRequestId: string | undefined;
  productTiles: ReadonlyArray<ILeanProductTile>;
  currentlySelectedPreorderSeasonName: string | undefined;
  showVerticalImagery: boolean;
}

export const useBrandProductResultData = (): IUseBrandProductResultData => {
  const { productsQueryPromise, legacyProductsQueryData, queryParams } =
    useBrandPageProductsStateContext();

  if (productsQueryPromise) {
    const productsData = use(productsQueryPromise);

    return {
      productSearchRequestId: productsData?.request_id,
      productTiles: queryParams?.collections
        ? []
        : (productsData?.product_tiles ?? []),
      currentlySelectedPreorderSeasonName:
        productsData?.currently_selected_category?.season_year_name,
      showVerticalImagery: !!productsData?.should_show_vertical_image,
    };
  }

  return {
    productSearchRequestId: legacyProductsQueryData?.productSearchRequestId,
    productTiles: legacyProductsQueryData?.productTiles ?? [],
    currentlySelectedPreorderSeasonName:
      legacyProductsQueryData?.currentlySelectedPreorderSeasonName,
    showVerticalImagery: !!legacyProductsQueryData?.showVerticalImagery,
  };
};
